import { Box, ButtonBase, Grid, IconButton, Typography } from "@mui/material";
import { useState } from "react";

import { trackEvent } from "utils/tracking";

import VideoDialog from "./VideoDialog";

interface Props {
  image: string;
  link: string;
  title: string;
  videoPreview?: string;
  widthPercentage?: number;
  isSmall?: boolean;
  isCentered?: boolean;
  previewHeight?: number | Record<string, number>;
  dialogMaxWidth?: number;
}

const StyledVideo = ({
  image,
  link,
  title,
  videoPreview,
  widthPercentage = 100,
  isSmall,
  isCentered = false,
  previewHeight,
  dialogMaxWidth,
}: Props) => {
  const styles = {
    bg2: {
      backgroundImage: `linear-gradient(to bottom, transparent 0%, black 100%), url(${image})`,
      width: "100%",
      height: previewHeight ?? { xs: 300, lg: 400 },
      borderRadius: 4,
      backgroundSize: "cover",
      backgroundPosition: "center",
      color: "white",
      display: "flex",
      justifyContent: "flex-end",
      flexDirection: "column",
      px: 3,
      pb: 1,
      "&:hover": {
        opacity: 0.9,
      },
    },
    smallBg: {
      backgroundImage: `linear-gradient(to bottom, transparent 0%, black 100%), url(${image})`,
      width: 150,
      height: 150,
      borderRadius: 50,
      backgroundSize: "cover",
      backgroundPosition: "center",
    },
    image: {
      objectFit: "cover",
      width: "100%",
    },
    icon: {
      background: "rgba(255, 255, 255, 0.3)",
      color: "white",
      fontSize: 30,
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
    },
  };

  const [open, setOpen] = useState(false);
  const playVideo = () => {
    trackEvent("Onboarding Video Clicked", { title });
    setOpen(true);
  };

  return (
    <Box
      sx={
        isCentered
          ? { display: "flex", flexDirection: "column", alignItems: "center" }
          : {}
      }
    >
      <ButtonBase
        onClick={playVideo}
        sx={{ width: isSmall ? "fit-content" : "100%" }}
      >
        <Box sx={isSmall ? styles.smallBg : styles.bg2}>
          <IconButton sx={styles.icon}>
            <Box component="i" className="fa-regular fa-circle-play" />
          </IconButton>

          {!isSmall && (
            <Box>
              <Typography
                textAlign="center"
                sx={{ color: "white", fontSize: 18, fontWeight: 600 }}
              >
                {title}
              </Typography>

              <Box
                sx={{
                  width: "100%",
                  my: 1,
                  borderColor: "white",
                  border: "3px solid",
                  opacity: 0.3,
                  borderRadius: 4,
                }}
              />
            </Box>
          )}
        </Box>
      </ButtonBase>

      {isSmall && (
        <Grid item xs={12} sx={{ mt: 1 }}>
          <Typography
            textAlign="center"
            color="textSecondary"
            variant="caption"
          >
            {title}
          </Typography>
        </Grid>
      )}

      <VideoDialog
        title={title}
        videoPreview={videoPreview}
        open={open}
        handleClose={() => setOpen(false)}
        link={link}
        widthPercentage={widthPercentage}
        dialogMaxWidth={dialogMaxWidth}
      />
    </Box>
  );
};

export default StyledVideo;
